import { useSelector } from "react-redux";
import Intercom from "../../../shared/components/Intercom";
import { useUserContext } from "../../contexts/UserContext";
import { selectClientSettings } from "../../store/selectors/clientSettingsSelectors";

const IntercomSettingsProvider = () => {
  const clientSettings = useSelector(selectClientSettings);
  const user = useUserContext();

  return (
    <>
      {clientSettings?.intercomAuthentication !== undefined && (
        <Intercom fullName={user.name} email={user.email} settings={clientSettings?.intercomAuthentication} />
      )}
    </>
  );
};

export default IntercomSettingsProvider;
